import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "chat",
    name: "Chat",
    version: "0.2.0",
    tier: "addon",
    accent: "people",
    description: "Team Chat: message anyone in the company, one to one, in groups or in your site's channel. Photos, voice notes, replies, reactions, @mentions, shift handovers, announcements with \"Got it\", read receipts and who's online. Messages stay in the company, not on personal phones.",
    permissions: {
        use: "Chat with people in the company",
        announce: "Post announcements (with a \"Got it\" to tap) and write in the Announcements channel",
        manage: "Chat settings: which features are on, quick replies, site channels and how long messages are kept",
        oversee: "Read any conversation (each look is recorded)",
    },
    grants: { "Head office": ["use", "announce"], "Area manager": ["use"], "Site manager": ["use"], "Supervisor": ["use"], "Staff": ["use"] },
    nav: [
        { label: "Chat", path: "/chat", section: "people", tab: "Chat", tabIcon: "message", permission: "use", icon: "message", order: 20, blurb: "Message people, groups and your site's channel" },
        { label: "Chat oversight", path: "/chat/oversee", section: "people", tab: "Chat", tabIcon: "message", permission: "oversee", icon: "eye", order: 90, blurb: "Read any conversation; every look is recorded" },
        { label: "Chat settings", path: "/chat/settings", section: "people", tab: "Chat", tabIcon: "message", kind: "settings", permission: "manage", icon: "settings", order: 91, blurb: "Features, quick replies, site channels, keeping messages" },
    ],
});
